import { FC } from 'react';
import FieldGroupSearch, { FieldGroupSearchProps } from '../FieldGroupSearch';
import SearchFormItem from './subpage/searchFormItem';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormFieldGroupSearchProps extends BaseSearchFormItemProps {
  /** fieldGroupSearch Props */
  fieldGroupSearchProps?: FieldGroupSearchProps;
}
/** 类型+字段+(匹配规则+多行输入框) 组合搜索 */
export const SearchFormFieldGroupSearch: FC<SearchFormFieldGroupSearchProps> = props => {
  const {
    fieldGroupSearchProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || fieldGroupSearchProps?.disabled}
      name={name}
      label={label}
      rules={rules}
    >
      <FieldGroupSearch
        test-id={`${testId}-${name}`}
        {...fieldGroupSearchProps}
        disabled={isDetail || fieldGroupSearchProps?.disabled}
      />
    </SearchFormItem>
  );
};

SearchFormFieldGroupSearch.displayName = SearchFormItemEnum.SearchFormFieldGroupSearch;

export default SearchFormFieldGroupSearch;
